/**
 * Change history of one listing (docs/phase-5-plan.md). Super admin only: the
 * rules refuse everyone else. Entries are written by the recordListingHistory
 * Cloud Function, never from the site.
 */
import { useEffect, useState } from 'react';
import { collection, limit as limitTo, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../config/firebase';
import { HistoryEntry } from '../utils/listingHistory';
import { LISTINGS_COLLECTION } from './useListings';

export const HISTORY_PAGE_SIZE = 20;

/** The newest `count` entries, live-updating (a "Put back" shows straight away). */
export function useListingHistory(listingId: string, count: number) {
  const [entries, setEntries] = useState<HistoryEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    const q = query(
      collection(db, LISTINGS_COLLECTION, listingId, 'history'),
      orderBy('at', 'desc'),
      limitTo(count)
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        setEntries(snapshot.docs.map((d) => ({ id: d.id, ...d.data() }) as HistoryEntry));
        setError(null);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      }
    );
    return unsubscribe;
  }, [listingId, count]);

  return { entries, loading, error, mayHaveMore: entries.length >= count };
}
